var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"12"}},[_c('taxcodedetails')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }